import { Inject, Injectable } from "@angular/core";
import { BimModel } from "../bim-model.interface";
import { BimModelsModalComponent } from "./bim-model-selection-modal/bim-model-selection-modal.component";
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { BehaviorSubject, catchError, firstValueFrom, map, Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Injectable({ providedIn: 'root' })
export class BimModelSelectionService {

  constructor(private readonly httpClient: HttpClient,
    private sanitizer: DomSanitizer,
    private readonly matDialog: MatDialog) { }

  private selectedBimModelSubject = new BehaviorSubject<BimModel>(null);
  selectedBimModel$ = this.selectedBimModelSubject.asObservable();

  setSelectedBimModel(model: BimModel) {
    this.selectedBimModelSubject.next(model);
  }

  submitForm() {
  }

  initForm() {
  }

  public async startBimModelSelectionDialog(bimModels: BimModel[]): Promise<BimModel> {
    const config = {
      width: '750px',
      alignSelf: 'center',
      height: 'auto',
      maxHeight: 'calc(100% - 52px)',
      autoFocus: false,
      disableClose: false,
      panelClass: ['mydocma-dialog', 'mydocma-dialog-xs-fullscreen', 'mydocma-co-dialog'],
      data: {
        bimModels: bimModels,
      }
    };
    const dialogRef = this.matDialog.open(BimModelsModalComponent, config);
    await firstValueFrom(dialogRef.afterClosed());
    return this.selectedBimModelSubject.value
  }

}
